import React from "react";
import { Box, Link } from "@chakra-ui/react";
import { ClickEventType } from "../../types";
import { customEvent } from "../../utils";
import { colors } from "../../styles";

export function FixedBottomButton({
  backgroundColor,
  text,
  href,
  event,
  onClick,
  bottom = "0px",
  right = "0px",
  maxWidth = "600px",
  height = "56px",
  borderRadius = "8px",
  barBackgroundColor = colors.white,
}: {
  backgroundColor?: string;
  text: string;
  href?: string;
  event?: ClickEventType;
  onClick?: () => void;
  bottom?: string;
  right?: string;
  maxWidth?: string;
  height?: string;
  borderRadius?: string;
  barBackgroundColor?: string;
}) {
  const onClickLink = () => {
    if (event) {
      const commonEvent: ClickEventType = { ...event, domain: "common" };
      try {
        customEvent(event);
        customEvent(commonEvent);
      } catch {}
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <Box
      style={{
        width: "100%",
        height: "84px",
        position: "fixed",
        bottom: bottom,
        right: right,
        zIndex: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: barBackgroundColor,
      }}
    >
      <Box style={{ width: "100%", maxWidth: maxWidth, padding: "0 20px" }}>
        <Link
          href={href}
          onClick={onClickLink}
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
          style={{
            background: backgroundColor || "",
            border: backgroundColor ? "" : "1px solid #8f8f8f",
            color: backgroundColor ? "white" : "#252525",
            borderRadius: borderRadius,
            textAlign: "center",
            boxShadow: "0px 6px 16px #0000001a",
            height: height,
          }}
        >
          <Box className="subtitle_16_b" textAlign="center">
            {text}
          </Box>
        </Link>
      </Box>
    </Box>
  );
}
